export default __webpack_public_path__ + "static/media/P10023.3cb59719.png";